import { Badge, Tooltip } from '@mantine/core';
import { ReactElement } from 'react';

export function IssuesCell({ issues }: { issues: string[] }): ReactElement {
  if (issues.length === 0) {
    return (
      <Badge color="green" variant="light">
        Ready
      </Badge>
    );
  }
  return (
    <Tooltip label={issues.join('\n')} multiline style={{ whiteSpace: 'pre-line' }}>
      <Badge color="orange" variant="light">
        {issues.length} open
      </Badge>
    </Tooltip>
  );
}
